import Phaser from "phaser"

import { cScene } from "../cScene";
import { ScreenItem } from "../dataTypes";
import { cText } from "./cText";
import { ModuleCollection, Base } from "./modules";


export const parseAssetName = (st:any, type:string) => {
  if (!st) return ''
  let [asset,frame] = String(st).split(':')
  return (type==='asset') ? asset : frame;
}

export class cTextSprite extends Phaser.GameObjects.Container {
  
  public readonly isContainer: boolean = true;

  public modules: ModuleCollection;
  protected itemData: ScreenItem | undefined;  
  private sp: Phaser.GameObjects.Sprite
  private tx: Phaser.GameObjects.Text

  constructor(sc:cScene, data: ScreenItem){
    super(sc,0,0);
    this.modules = Base.initModules(this,data);

    var style =  sc.getStyle(data.textclass as string);
    this.sp = new Phaser.GameObjects.Sprite(sc,0,0, parseAssetName(data.asset,'asset') || '', parseAssetName(data.asset,'frame') )
    this.tx = new Phaser.GameObjects.Text(sc, 0,0,data.text as any,style);
    this.add(this.sp);
    this.add(this.tx);

    if (data.origin) this.imageorg = data.origin
    if (data.textstyle) style = {...style,...data.textstyle}
    cText.updateStyle(this.tx, style)
  }

  public set textdata( v:string ){
    this.tx.text = v;
    cText.updateStyle(this.tx,{})
  }

  public set textpos(v:string){
    var p = this.modules.layout.getOfs(v)    
    this.tx.x = p.x;
    this.tx.y = p.y;
  }

  public set imagepos(v:string){
    var p = this.modules.layout.getOfs(v)
    this.sp.x = p.x;
    this.sp.y = p.y;
  }

  public set imageorg(v:string){
    var p = this.modules.layout.getOfs(v)
    this.sp.setOrigin(p.x,p.y);
  }

}